@if (isMulti()) {
  <elcia-multi-dropdown
    [control]="control()"
    [items]="products()"
    [label]="'entity.product' | translate"
    textField="name"
    valueField="id"
  />
} @else {
  <elcia-dropdown
    [control]="control()"
    [items]="products()"
    [label]="'entity.product' | translate"
    textField="name"
    valueField="id"
  />
}
